import { ReportSignatureKey } from "domain/reportSignatureKeys";
import { apiGatewayService } from "services/api/ApiGatewayService";

const PATH_API_REPORT_SIGNATURE_KEYS = "/api/report-signature-keys";

interface ReportSignatureKeyDto {
    name: string;
    fingerprint: string;
    created: string;
    creator_uuid: string;
    creator_email: string;
}

interface ReportSignatureKeysResponseDto {
    report_signature_keys: ReportSignatureKeyDto[];
}

function toReportSignatureKey(dto: ReportSignatureKeyDto): ReportSignatureKey {
    return {
        name: dto.name,
        fingerprint: dto.fingerprint,
        created: dto.created,
        creatorUuid: dto.creator_uuid,
        creatorEmail: dto.creator_email,
    };
}

class ReportSignatureKeyService {
    public fetchKeys(abortController?: AbortController): Promise<ReportSignatureKey[]> {
        return apiGatewayService
            .invokeApi(PATH_API_REPORT_SIGNATURE_KEYS, "GET", null, {
                abortSignal: abortController?.signal,
            })
            .then((dto: ReportSignatureKeysResponseDto) => dto.report_signature_keys.map(toReportSignatureKey));
    }

    public createKey(name: string, key: string, abortController: AbortController): Promise<void> {
        return apiGatewayService.invokeApi(
            PATH_API_REPORT_SIGNATURE_KEYS,
            "POST",
            { name, key },
            {
                abortSignal: abortController.signal,
                emptyResponse: true,
            }
        );
    }

    public renameKey(oldName: string, newName: string, abortController: AbortController): Promise<void> {
        return apiGatewayService.invokeApi(
            `${PATH_API_REPORT_SIGNATURE_KEYS}/${encodeURIComponent(oldName)}`,
            "POST",
            { name: newName },
            {
                abortSignal: abortController.signal,
                emptyResponse: true,
            }
        );
    }

    public deleteKey(name: string, abortController: AbortController): Promise<void> {
        return apiGatewayService.invokeApi(
            `${PATH_API_REPORT_SIGNATURE_KEYS}/${encodeURIComponent(name)}`,
            "DELETE",
            null,
            {
                abortSignal: abortController.signal,
                emptyResponse: true,
            }
        );
    }
}

export const reportSignatureKeyService = new ReportSignatureKeyService();
